export default __webpack_public_path__ + "static/media/ic_notifications_active_48px.445b32db.svg";